import { cssColorValue, semanticColors, spacer32, spacer40 } from '@spotify-internal/encore-web';
import React, { useState } from 'react';
import styled from 'styled-components';

import { useVerticalContext } from 'providers/vertical';
import { NavigationConfig } from 'utils/vertical';

import { NavigationMenu } from './Menu';
import { NavBarCountryRegionPicker } from './CountryRegionPicker';
import { StyledTextLink } from './StyledTextLink';
import { NavigationBrand } from './Brand';

const HeaderWrapper = styled.header`
  align-items: center;
  background: #000;
  color: ${cssColorValue(semanticColors.textBase)};
  display: flex;
  justify-content: space-between;
  height: 80px;
  padding-inline: ${spacer40};
`;

const NavList = styled.ul`
  align-items: center;
  display: flex;
  gap: ${spacer32};
  list-style: none;
  margin: 0;
  padding: 0;
`;

type Props = {
  config: NavigationConfig;
};

export const NavigationHeader = ({ config: { linksConfig, colorSet } }: Props) => {
  const { domain } = useVerticalContext();
  const [openMenu, setOpenMenu] = useState<Record<string, boolean>>(() =>
    linksConfig.reduce<Record<string, boolean>>((acc, curr) => {
      if ('links' in curr) {
        return { ...acc, [curr.menuKey]: false };
      }
      return acc;
    }, {}),
  );

  // TODO: track click events
  const handleOpenMenu = (key: string) => {
    setOpenMenu({ [key]: true }); // closes all other menus
  };

  // TODO: track click events
  const handleCloseMenu = (key: string) => {
    setOpenMenu(currState => ({ ...currState, [key]: false }));
  };

  return (
    <div className={colorSet}>
      <HeaderWrapper role="banner">
        <NavigationBrand />
        <nav role="navigation">
          <NavList>
            {linksConfig.map(item => {
              return (
                <li key={item.label}>
                  {'links' in item ? (
                    <NavigationMenu
                      onClose={handleCloseMenu}
                      onOpen={handleOpenMenu}
                      open={openMenu[item.menuKey]}
                      {...item}
                    />
                  ) : (
                    <StyledTextLink href={`${item.href}/`}>{item.label}</StyledTextLink>
                  )}
                </li>
              );
            })}
          </NavList>
        </nav>
        <div>
          <NavList>
            <li>
              <NavBarCountryRegionPicker />
            </li>
            <li>
              <StyledTextLink href={`https://accounts.spotify.com/login?nosignup=true&continue=https://${domain}/`}>
                Log in
              </StyledTextLink>
            </li>
            <li>
              <StyledTextLink href="https://artists.spotify.com/claim">Get access</StyledTextLink>
            </li>
          </NavList>
        </div>
      </HeaderWrapper>
    </div>
  );
};
